import create, { StateCreator, StoreApi } from "zustand";
import configService from "@services/config.service";
import { milleniumClientCheck } from "@utils/helpers";

interface IConfigStore {
  accessLevel: string;
  isPatientReadOnly: string;
  setisPatientReadOnly: (value: string) => void
  canEdit: (isPatientReadOnly?: string) => boolean;
  config: any;
  loader: boolean;
  fetchConfig: () => Promise<void>;
  setConfigValues: (configList: any, role: string, accessLevel: string) => void;
  clearStore: () => void;
  sessionTimeoutDuration : any,
  setSessionTimeoutDuration : (x:any) => void
}

let store: StateCreator<IConfigStore, [], [], IConfigStore> | StoreApi<IConfigStore> = (set, get) => ({
  accessLevel: "",
  isPatientReadOnly: "",
  setisPatientReadOnly: (value: string) => {
    set(() => ({ isPatientReadOnly: value }))
  },
  canEdit: function (isPatientReadOnly?: string) {
    let store = get();
    if (milleniumClientCheck()) {
      return store.accessLevel.includes("W") && store.isPatientReadOnly !== "Y" && isPatientReadOnly !== 'Y';  
    }
    return store.accessLevel.includes("W");
  },
  config: null,
  loader: true,
  fetchConfig: async () => {
    set(() => ({ loader: true }));
    configService.getAppConfig().subscribe({
      next: (v) => get().setConfigValues(v.data.data?.[0]?.configOptions, v.data.data?.[0]?.role, v.data.data?.[0]?.accessLevel || ""),
      error: (e) => {
        set(() => ({ loader: false }));
      },
      complete: () => set(() => ({ loader: false })),
    });
  },
  setConfigValues: (configList: any, role: string, accessLevel: string) => {
    const config: any = {};
    if (!configList) {
      return;
    }
    configList.forEach((conf: any) => {
      if (!config[conf["config_optn_grp_name"]]) {
        config[conf["config_optn_grp_name"]] = {};
      }
      config[conf["config_optn_grp_name"]][conf["config_optn_name"]] = JSON.parse(conf["config_optn_val"]);
    });
    config["role"] = role;

    set(() => ({ config: config, accessLevel }));
  },
  sessionTimeoutDuration: "1800000",
  setSessionTimeoutDuration: (x) => {
    set(() => ({ sessionTimeoutDuration: x }));
  },
  clearStore: () => {
    set(() => ({ config: null }));
    set(() => ({ sessionTimeoutDuration: "1800000" }));
  },
});

export const useConfigStore = create(store);
